'use client'

import { formatDateNormal, formatImageURL } from "@/utils/util"
import { getFacebookShareUrl, getTwitterShareUrl, openSharePopup, copyToClipboard } from "@/utils/share"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"
import { toast } from "@/lib/toast"
import BlogCard from "./BlogCard"

const focusRing = 'focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground'
const sweepLink = `pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] hover:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none ${focusRing}`

export default function BlogDetail({ blog, related = [] }: { blog: any, related?: any[], vendor?: any }) {
  const pathname = usePathname()

  const onShareFacebook = () => openSharePopup(getFacebookShareUrl(window.location.href))
  const onShareTwitter = () => openSharePopup(getTwitterShareUrl(window.location.href, blog?.title || ''))
  const onCopyLink = async () => {
    const ok = await copyToClipboard(window.location.href)
    if (ok) toast.success('Холбоос хуулагдлаа')
    else toast.error('Хуулж чадсангүй')
  }

  return (
    <div className="w-full pb-16">
      <article className="mx-auto w-full max-w-4xl px-4 lg:px-6 pt-8 lg:pt-14">
        <nav aria-label="Breadcrumb" className="flex items-center gap-x-1.5 text-xs text-muted-foreground">
          <a href={navigateUrl('/blog', pathname)} className={`transition-colors duration-150 hover:text-foreground ${focusRing}`}>Нийтлэл</a>
          <span aria-hidden>/</span>
        </nav>

        <h1 className="mt-4 text-3xl sm:text-5xl leading-tight tracking-tight text-foreground text-pretty">{blog.title}</h1>
        <time className="mt-4 block text-sm text-muted-foreground tabular-nums">{formatDateNormal(new Date(blog.createdAt))}</time>

        {blog.thumbnail && (
          <div className="mt-10 aspect-19/10 bg-muted overflow-hidden">
            <img src={formatImageURL(blog.thumbnail)} alt="" className="w-full h-full object-cover" />
          </div>
        )}

        <div
          className="mt-10 blog-detail prose prose-neutral max-w-none text-foreground prose-headings:font-medium prose-headings:tracking-tight prose-headings:text-foreground prose-p:text-[15px] sm:prose-p:text-base prose-p:leading-[1.8] prose-p:text-foreground/85 prose-li:text-foreground/85 prose-strong:text-foreground prose-a:text-foreground prose-a:underline-offset-4 prose-a:decoration-1 prose-img:w-full prose-img:rounded-none prose-blockquote:border-l prose-blockquote:border-foreground prose-blockquote:font-normal prose-blockquote:not-italic"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        <div className="mt-12 pt-6 border-t border-border flex flex-wrap items-center gap-x-6 gap-y-2 text-[13px]">
          <span className="text-muted-foreground">Хуваалцах:</span>
          <button type="button" onClick={onShareFacebook} className={sweepLink}>Facebook</button>
          <button type="button" onClick={onShareTwitter} className={sweepLink}>X</button>
          <button type="button" onClick={onCopyLink} className={sweepLink}>Холбоос хуулах</button>
        </div>
      </article>

      {related.length > 0 && (
        <section className="pt-16 lg:pt-24">
          <h2 className="px-4 lg:px-6 mb-8 lg:mb-10 text-2xl sm:text-4xl tracking-tight text-foreground">Бусад нийтлэл</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-1">
            {related.slice(0, 3).map(post => <BlogCard key={post.id} blog={post} />)}
          </div>
        </section>
      )}
    </div>
  )
}
